export const BUSINESS_TYPE = {
    '9': "CAFE",
    '13': "FASHION"
}

export const METRICS = {
    REPEAT_VISITS: 'REPEAT_VISITS',
    QR_VISITS: 'QR_VISITS',
    DIRECT_VISITS: 'DIRECT_VISITS',
    DEALS_CLAIMED: 'DEALS_CLAIMED',
    SHARES: 'SHARES',
    SHARE_VISITS: 'SHARE_VISITS',
    SHARE_DEALS_CLAIMED: 'SHARE_DEALS_CLAIMED',
    STORE_BROWSE: 'STORE_BROWSE',
    ENQUIRIES: 'ENQUIRIES',
    BASKET_ADD: 'BASKET_ADD',
    RE_ORDER: 'RE_ORDER'
}